import React, { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa6";
import { useAppSelector } from "../../../../hooks/reduxDispatch";
import { FaCopy } from "react-icons/fa6";
import { apiSuccessCall } from "../../../../utils/apiErrorCall";

const WebsiteEmbed = () => {
  const [embedStructure, setEmbedStructure] = useState();

  const { singleBotdata } = useAppSelector((s) => s.userBot);

  useEffect(() => {
    const structure = `<script
    id="botScript"
    src="https://intelliver.app/iframe?botId=${singleBotdata.botId}"
    domain="www.intelliver.app"
    defer
  ></script>`;
    setEmbedStructure(structure);
  }, []);

  // `<div className="fixed bottom-0 top-0 right-0 z-50">
  // <iframe
  //   id="chatBot_iFrame"
  //   src="https://intelliver.app/iframe?botId=${singleBotdata.botId}"
  //   width="450px"
  //   height="100%"
  //   maxwidth="100%"
  //   frameBorder="0"
  // ></iframe>
  // </div>`;

  const processCopy = () => {};

  return (
    <div className="border-2 w-full py-10 border-dashed border-gray-300 rounded p-6 ">
      <p>{embedStructure}</p>
      <div
        className="flex items-center gap-4 bg-black rounded-xl justify-center py-1 mt-4 cursor-pointer"
        onClick={() => {
          apiSuccessCall("Code copied to clipboard");
          navigator.clipboard.writeText(embedStructure);
        }}
      >
        <p className="text-sm text-lg text-white">Copy script</p>
        <div className="flex mb-2">
          <FaCopy size={30} color="white" />
        </div>
      </div>
    </div>
  );
};

export default WebsiteEmbed;
